import { render } from "./FormEntregaPdfPage.vue?vue&type=template&id=444a8b4a&scoped=true"
import script from "./FormEntregaPdfPage.vue?vue&type=script&lang=js"
export * from "./FormEntregaPdfPage.vue?vue&type=script&lang=js"

import "./FormEntregaPdfPage.vue?vue&type=style&index=0&id=444a8b4a&scoped=true&lang=scss"

import exportComponent from "C:\\GIT CLONADO\\ubiku.2023\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-444a8b4a"]])

export default __exports__